var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimatedCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 238,
    viewBox: "0 0 245 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245,
    height: 238
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M152 129C178.51 129 200 107.957 200 82C200 56.0426 178.51 35 152 35C125.49 35 104 56.0426 104 82C104 107.957 125.49 129 152 129Z",
    fill: "#EFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M152.359 7.4375V23.9487",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M152.359 139.676V156.188",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.7969 81.8125H92.832",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M211.925 81.8125H228.922",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M98.2297 29.2294L110.25 40.9062",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M194.469 122.719L206.489 134.396",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M98.2297 134.396L110.25 122.719",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M194.469 40.9062L206.489 29.2294",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M89.9609 59.1281C102.164 59.1041 114.141 62.3201 124.599 68.4285C135.056 74.537 143.597 83.3057 149.297 93.7869C156.28 89.8206 164.11 87.4712 172.18 86.9211C180.249 86.371 188.341 87.6351 195.826 90.615C203.311 93.595 209.988 98.2108 215.339 104.104C220.69 109.997 224.571 117.009 226.68 124.595C228.79 132.182 229.071 140.138 227.502 147.847C225.932 155.556 222.555 162.81 217.633 169.045C212.71 175.281 206.374 180.33 199.117 183.802C191.86 187.273 183.877 189.073 175.788 189.061L89.9609 189.284C72.1935 189.284 55.1538 182.428 42.5903 170.223C30.0268 158.019 22.9688 141.466 22.9688 124.206C22.9687 106.946 30.0268 90.3936 42.5903 78.1891C55.1538 65.9845 72.1935 59.1281 89.9609 59.1281V59.1281Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M226.369 151.662C234.192 124.464 217.836 96.255 189.838 88.6559C161.84 81.0569 132.801 96.9453 124.979 124.144C117.156 151.342 133.512 179.551 161.51 187.15C189.509 194.749 218.547 178.86 226.369 151.662Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "drop3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector3",
    d: "M147.383 198.953V202.672",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector3_2",
    d: "M147.383 221.266V224.984",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "drop1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector1",
    d: "M101.445 198.953V202.672",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector1_2",
    d: "M101.445 221.266V224.984",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "drop2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector2",
    d: "M124.414 206.391V210.109",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector2_2",
    d: "M124.414 228.703V232.422",
    stroke: "#0BAEFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 73.0406,
    y1: 194.825,
    x2: 150.866,
    y2: 91.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 197.198,
    y1: 119.728,
    x2: 137.714,
    y2: 172.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedCloud);
export default __webpack_public_path__ + "static/media/animatedCloud.26839f9dc0e62a9a12813f273ff42cd5.svg";
export { ForwardRef as ReactComponent };